<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { MapInfoItem } from '@/models/MapInfoItem.model';

/**
 *
 * @version 1.0.0
 * @since
 */
export default defineComponent({
	name: 'MapInfo',
	props: {
		title: {
			required: false,
			type: String,
			default: (): string => '',
		},
    variableDescription: {
      required: false,
      type: String,
      default: (): string => '',
    },
		list: {
			required: true,
			type: Array as PropType<MapInfoItem[]>,
			default: (): MapInfoItem[] => [],
		},
	},
});
</script>

<template>
	<div class="map-info">
		<h4
			v-if="title"
			class="map-inf__text"
		>
			{{ title }}
		</h4>
		<p
			v-if="variableDescription"
			class=" map-info__variable-description"
		>
			{{ variableDescription }}
		</p>
		<template
			v-for="(item, index) in list"
			:key="JSON.stringify(item) + index"
		>
			<div class="map-info__info-item-wrapper">
				<p class="map-info__info-title map-inf__text">
					{{ item.title }}
				</p>
				<p class="map-inf__text">
					{{ item.text }}
				</p>
			</div>
		</template>
	</div>
</template>

<style scoped lang="scss">
.map-info {
  display: flex;
	flex-direction: column;
  gap: 4px;

  max-width: 200px;
	padding: 16px;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #0000002e;
	border-radius: 6px;
  background: white;

}

.map-info__info-item-wrapper {
  display: flex;
  flex-direction: column;
  @include tools.font-size(12px, 18px);
}

.map-inf__text {
	margin: 0;
	font-weight: 500;
  color: #212529;
}

.map-info__info-title {
	color: #6C757D;
}

.map-info__variable-description {
  font-size: 12px;
  font-weight: 400;
  color: #6C757D;
}
</style>
